if (!customElements.get('redirect-frame-finder')) {
    class RedirectFrameFinder extends HTMLElement {
        constructor() {
            super();
            this.url = CookieUtils.getCookie(FRAME_FINDER_KEYS.filteredUrlKey) || this.dataset.collection;
        }

        connectedCallback() {
            const redirectButton = this.querySelector('.ff-redirect-btn');
            if (redirectButton) {
                redirectButton.addEventListener('click', (e) => this.handleRedirect(e));
            }
        }

        handleRedirect(e) {
            e.preventDefault();
            if (this.url) {
                window.location.href = this.url;
            }
        }
    }

    customElements.define('redirect-frame-finder', RedirectFrameFinder);
}